import { useField } from 'formik'

import { modalFilterButton } from '@/components/ListingFiltersModal/style.css'

type Props = React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> & {
  name: string
  onChange?: (value: string) => void
  options: { text: string; value: string }[]
}

export const FormikOneOptionSelector: React.FC<Props> = ({ name, onChange = () => {}, options, ...props }) => {
  const [_, meta, helpers] = useField<string>(name)
  const { value } = meta
  const { setValue } = helpers

  const select = (value: string) => {
    return () => {
      setValue(value)
      onChange(value)
    }
  }

  return (
    <div>
      {options.map((option, index) => (
        <div
          key={index}
          className={modalFilterButton({ active: value === option.value })}
          role="button"
          tabIndex={0}
          onClick={select(option.value)}
          {...props}
        >
          {option.text}
        </div>
      ))}
    </div>
  )
}
